document.addEventListener('DOMContentLoaded', () => {
    const wishlistElement = document.querySelector('header status-saved-link');
    const wishlistInnerLink = wishlistElement === null || wishlistElement === void 0 ? void 0 : wishlistElement.shadowRoot.querySelector('a');
    wishlistInnerLink === null || wishlistInnerLink === void 0 ? void 0 : wishlistInnerLink.insertAdjacentHTML('beforeend', `<style>.saved-link:focus,.saved-link:focus-visible{ outline: none; }</style>`);
});
document.addEventListener('status:loaded', () => {
    const statusApp = document.getElementById('status-app');
    if (statusApp) {
        const appWidget = statusApp.shadowRoot.querySelector('.widget');
        const mutationConfig = { attributes: true, childList: true, subtree: true };
        const mutationFunction = () => {
            const statusAppLinks = appWidget.querySelectorAll('a');
            statusAppLinks.forEach((link) => {
                if (link.hasAttribute('target')) {
                    link.removeAttribute('target');
                }
            });
        };
        const observer = new MutationObserver(mutationFunction);
        observer.observe(appWidget, mutationConfig);
    }
});
